<template>
<div class="chapter">
<div class="inner_page">
<p class="copyrighta">Copyright © 2007 by Jim Harrison</p>
<p class="copyrighta">All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, or the facilitation thereof, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.</p>
<p class="copyrighta"><em>Printed in the United States of America</em></p>
<p class="copyrighta"><span class="small">FIRST PAPERBACK EDITION</span></p>
<p class="copyrighta">Library of Congress Cataloging-in-Publication Data<br/>Harrison, Jim, 1937–<br/>Returning to Earth / Jim Harrison,<br/>p. cm.</p>
<p class="copyright">ISBN-10: 0-8021-4331-8</p>
<p class="copyright">ISBN-13: 978-0-8021-4331-0</p>
<p class="copyrighta">1. Amyotrophic lateral sclerosis—Patients—Fiction. 2. Death—Fiction.<br/>3. Indians—Mixed descent—Fiction. 4. Upper Peninsula (Mich.)—Fiction.<br/>5. Family—Fiction. 6. Memory—Fiction. I. Title.<br/>PS3558.A67R4 2007<br/>813’.54—dc22           2006050802</p>
<p class="copyrighta">Grove Press<br/>an imprint of Grove/Atlantic, Inc.<br/>841 Broadway<br/>New York, NY 10003</p>
<p class="copyrighta">Distributed by Publishers Group West</p>
<p class="copyrighta"><span class="weblink"><a class="nounder" href="http://www.groveatlantic.com" target="_blank">www.groveatlantic.com</a></span></p>
<p class="copyrighta">07 08 09 10 11 12 10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?7339b4d9